// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609140106/js/" + chunkId + "." + {"44":"d9977a02","225":"36da1755","481":"61e3e73e","486":"bf87191e","770":"5bade469"}[chunkId] + ".0.058755047671353866.chunk.js";
};